import { useForm } from 'react-hook-form';
import { Alert, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ModalForm from '@components/common/hooks/useFormModal/ModalForm';
import RadioButtonGroup from '@components/common/HookFormMui/RadioButtonGroup';

const stringsToOptions = (labels) => labels.map((label) => ({ id: label, label }));

const CancelModal = ({
  onSubmit,
  submitRef,
  defaultValues = {},
  hasCompleted,
}) => {

  const form = useForm({
    mode: 'onSubmit',
    defaultValues,
  });

  return (
    <ModalForm
      form={form}
      onSubmit={onSubmit}
      submitRef={submitRef}
    >
      <Grid container spacing={1}>
        <Grid xs={12}>
          <Typography variant="h3" color="#000">
            Why is this session canceled?
          </Typography>
        </Grid>
        {hasCompleted && (
          <Grid xs={12}>
            <Alert severity="warning">
              This session has "Complete Session" data entered. If you click the Cancel Session button below the data will be deleted and your session will be canceled.
            </Alert>
          </Grid>
        )}
        <Grid xs={12} sm={10}>
          <RadioButtonGroup
            key="key-cancel_reasons"
            id="field-cancel_reason"
            name="cancel_reason"
            formLabelProps={{
              component: 'h2',
              style: {
                marginTop: 0,
                fontSize: '20px',
              }
            }}
            placeholder={'Select reason'}
            control={form.control}
            fullWidth
            required
            otherTextField
            otherTextFieldLabel={'If Other, please describe reason below*'}
            options={stringsToOptions([
              'No participants showed up',
              'Partner requested to cancel',
              'Staffing emergency',
              'Created by mistake',
              'Other',
            ])}
          />
        </Grid>
      </Grid>
    </ModalForm>
  );
};

export default CancelModal;
